export const SET_CURRENT_USER = "auth/SET_CURRENT_USER";
export const GET_CURRENT_USER = "auth/GET_CURRENT_USER";
export const LOGOUT_USER = "auth/LOGOUT_USER";
export const UPDATE_CALCULATION_VALUES = "auth/UPDATE_CALCULATION_VALUES";
